import { useState } from 'react';

import useScrollEffect from './useScrollEffect';

/**
 * React hook that will return the current location
 */
const useBoundingClientRect = (ref) => {
  const [location, setLocation] = useState();

  useScrollEffect(() =>
    setLocation(ref.current ? ref.current.getBoundingClientRect() : null)
  );

  return location;
};

export default useBoundingClientRect;
